<template>
  <Content title="2000+企业的肯定">
    <div class="d-flex flex-wrap">
      <img
        v-for="index in 12"
        :key="index"
        class="affirm-item-logo lazyload"
        :data-src="`/images/pages/tmc/affirm-${index >= 10 ? index : '0' + index}.png`"
      />
    </div>
  </Content>
</template>
<script>
import Content from '@/shared/components/content.vue'
export default {
  name: 'MobileAffirm',
  components: { Content },
}
</script>

<style lang="scss" scoped>
.affirm-item-logo {
  width: 30%;
  flex: 1;
}
</style>
